/*
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-05-19 09:49:33
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-04-20 01:11:10
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login'),
  },
  {
    path: '/no-permission',
    name: 'no-permission',
    component: () => import('@/pages/no-permission'),
  },
  {
    path: '/managet',
    name: 'managet',
    component: () => import('@/pages/managet'),
  },
  {
    path: '/schema',
    name: 'schema',
    component: () => import('@/pages/schema'),
  },
  {
    path: '/mall',
    name: 'mall',
    component: () => import('@/pages/mall'),
    redirect: '/mall/live',
    children: [
      {
        path: 'live',
        name: 'live',
        component: () => import('@/pages/mall/live/index'),
      },
      {
        path: 'pages-manage',
        name: 'pages-manage',
        component: () => import('@/pages/mall/pages-manage'),
      },
      {
        path: 'page-build',
        name: 'page-build',
        component: () => import('@/pages/mall/page-build'),
      },
      {
        path: 'goods',
        name: 'goods',
        component: () => import('@/pages/mall/goods'),
        redirect: '/mall/goods/goods-manager',
        children: [
          {
            path: 'goods-manager',
            name: 'goods-manager',
            component: () => import('@/pages/mall/goods/goods-manager/index'),
          },
          {
            path: 'goods-edit',
            name: 'goods-edit',
            component: () => import('@/pages/mall/goods/goods-manager/edit'),
          },
          {
            path: 'group-manager',
            name: 'group-manager',
            component: () => import('@/pages/mall/goods/group-manager/index'),
          },
        ]
      },
      {
        path: 'store',
        name: 'store',
        component: () => import('@/pages/mall/store'),
        redirect: '/mall/store/navigation-tpl',
        children: [
          {
            path: 'navigation-tpl',
            name: 'navigation-tpl',
            component: () => import('@/pages/mall/store/navigation-tpl'),
          },
          {
            path: 'search-tpl',
            name: 'search-tpl',
            component: () => import('@/pages/mall/store/search-tpl'),
          },
          {
            path: 'category-tpl',
            name: 'category-tpl',
            component: () => import('@/pages/mall/store/category-tpl'),
          },
          {
            path: 'list-tpl',
            name: 'list-tpl',
            component: () => import('@/pages/mall/store/list-tpl'),
          },
        ]
      },
      {
        path: 'material-center',
        name: 'material-center',
        component: () => import('@/pages/mall/material-center/index'),
      },
      {
        path: 'user',
        name: 'user',
        component: () => import('@/pages/mall/user/index'),
      },
      {
        path: 'user-edit',
        name: 'user-edit',
        component: () => import('@/pages/mall/user/user-edit'),
      },
      {
        path: 'guest',
        name: 'guest',
        component: () => import('@/pages/mall/guest/index'),
      },
      {
        path: 'guest-edit',
        name: 'guest-edit',
        component: () => import('@/pages/mall/guest/guest-edit'),
      },
      {
        path: 'guest-category',
        name: 'guest-category',
        component: () => import('@/pages/mall/guest/guest-category'),
        meta: {
          title: '嘉宾分组管理'
        }
      },
      {
        path: 'schedule',
        name: 'schedule',
        component: () => import('@/pages/mall/schedule/archive'),
        meta: {
          title: '日程管理'
        }
      },
      {
        path: 'schedule/matrix',
        name: 'schedule-matrix',
        component: () => import('@/pages/mall/schedule/index'),
        meta: {
          title: '日程矩阵'
        }
      },
      {
        path: 'schedule/venue',
        name: 'schedule-venue',
        component: () => import('@/pages/mall/schedule/venue'),
        meta: {
          title: '会场管理'
        }
      },
      {
        path: 'schedule/date',
        name: 'schedule-date',
        component: () => import('@/pages/mall/schedule/date'),
        meta: {
          title: '日期管理'
        }
      },
      {
        path: 'schedule/edit',
        name: 'schedule-edit',
        component: () => import('@/pages/mall/schedule/edit'),
        meta: {
          title: '编辑日程'
        }
      },
      {
        path: 'schedule/detail',
        name: 'schedule-detail',
        component: () => import('@/pages/mall/schedule/detail'),
        meta: {
          title: '日程详情'
        }
      },
      {
        path: 'schedule/sms-task-detail',
        name: 'sms-task-detail',
        component: () => import('@/pages/mall/schedule/sms-task-detail'),
        meta: {
          title: '短信任务详情'
        }
      },
      {
        path: 'permission',
        name: 'permission',
        component: () => import('@/pages/mall/permission/index'),
        redirect: '/mall/permission/admin-manage',
        children: [
          {
            path: 'admin-manage',
            name: 'admin-manage',
            component: () => import('@/pages/mall/permission/admin-manage'),
          },
          {
            path: 'role-manage',
            name: 'role-manage',
            component: () => import('@/pages/mall/permission/role-manage'),
          },
          {
            path: 'subAccount-manage',
            name: 'subAccount-manage',
            component: () => import('@/pages/mall/permission/subAccount-manage'),
          },
        ]
      }
      // {
      //   path: 'model-manage',
      //   name: 'model-manage',
      //   component: () => import('@/pages/mall/model-manage'),
      // },
    ]
  }
]

const router = new VueRouter({
  linkActiveClass: 'active',
  base: process.env.BASE_URL,
  routes
})

// 路由模块与权限模块映射
const ROUTE_MODULE_MAP = {
  'live': 'live',
  'pages-manage': 'pages',
  'page-build': 'page-build',
  'goods': 'goods',
  'store': 'site',
  'material-center': 'material',
  'user': 'user',
  'user-edit': 'user',
  'guest': 'guest',
  'guest-edit': 'guest',
  'guest-category': 'guest',
  'schedule': 'schedule',
  'schedule-matrix': 'schedule',
  'schedule-venue': 'schedule',
  'schedule-date': 'schedule',
  'schedule-edit': 'schedule',
  'schedule-detail': 'schedule',
  'sms-task-detail': 'schedule',
  'permission': 'permission',
  'admin-manage': 'permission',
  'role-manage': 'permission',
  'subAccount-manage': 'permission',
}

// 全局路由守卫鉴权
router.beforeEach((to, from, next) => {
  if (to.name == 'login' || to.name == 'no-permission') {
    next()
  } else {
    if (!store.getters.token) {
      next('/')
    } else {
      // 子账号权限检查
      const userInfo = store.getters.userInfo
      if (userInfo && userInfo.isSubAccount) {
        const permissions = store.getters.userPermissions || []
        const moduleName = ROUTE_MODULE_MAP[to.name]
        if (moduleName && permissions.length > 0) {
          const perm = permissions.find(p => p.module === moduleName)
          if (!perm || !perm.actions || !perm.actions.includes('view')) {
            // 无权限，跳转到第一个有权限的页面
            const firstPerm = permissions.find(p => p.actions && p.actions.includes('view'))
            if (firstPerm) {
              const moduleToPath = {
                'site': 'store',
                'pages': 'pages-manage',
                'permission': 'permission/admin-manage'
              }
              next({ path: `/mall/${moduleToPath[firstPerm.module] || firstPerm.module}` })
            } else {
              // 没有任何权限，跳转到无权限提示页
              next({ name: 'no-permission' })
            }
            return
          }
        }
      }
      next()
    }
  }
})

export default router
